var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn",class:{'btn__active': _vm.active},on:{"click":_vm.start}},[(_vm.active)?_c('span',[_vm._v(_vm._s(_vm.count)+"s")]):_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }